import React from 'react';

import { Text } from '../../styles';

// Question types
import DualIntegersDualAnswers from '../questions/dual_integers_dual_answers';
import DualOptionSetsSingleAnswer from '../questions/dual_option_sets_single_answer';
import SingleOptionSetSingleAnswer from '../questions/single_option_set_single_answer';
import SingleNumberSorted from '../questions/single_number_sorted';

const questionTypes = {
  'dual-integers-dual-answer': DualIntegersDualAnswers,
  'dual-option-sets-single-answer': DualOptionSetsSingleAnswer,
  'single-option-set-single-answer': SingleOptionSetSingleAnswer,
  'single-decimal-sorted': SingleNumberSorted,
  'single-integer-sorted': SingleNumberSorted,
  'single-duration-sorted': SingleNumberSorted,
};

const Question = ({ entry, question }) => {
  if (entry && question.question_data.type in questionTypes) {
    const El = questionTypes[question.question_data.type];

    return (
      <Text bold textAlign="center">
        <El data={entry.data.answers} question={question} />
      </Text>
    );
  } else {
    return <Text />;
  }
};

export default Question;
